export var BOOKERS_REFERENCE_MAX_LENGTH = 50;
export var TOTAL_DINNER_BUDGET_REGEX = /^\d*([.,]\d{0,2})?$/;
export var PAYMENT_FAILED_KEY = 'paymentStatus';
export var PAYMENT_FAILED_INFO_KEY = 'paymentFailureInfo';
export var PAYMENT_FAILURE_INFO_INITIAL_VALUE = {
  errCode: 0,
  debugMessage: '',
  globalErrTextTemplate: ''
};
export var PAYMENT_FAILURE_CODE_KEY = 'paymentFailureCode';
export var PAYMENT_FAILURE_CODE_INITIAL_VALUE = '';
export var PAYMENT_FAILURE_DESCRIPTION_KEY = 'paymentFailureDescription';
export var PAYMENT_FAILURE_DESCRIPTION_INITIAL_VALUE = '';
export var PAYMENT_ANALYTICS_KEY = 'paymentAnalytics';
export var PAYMENT_ANALYTICS_INITIAL_VALUE = {
  paymentSessionID: '',
  paymentTemplateID: '',
  cardNotPresent: false,
  paymentCardSelected: '',
  paymentTakenNow: '',
  basketReference: ''
};
export var PAYMENT_FAILED_INITIAL_VALUE = '';
export var PAYMENT_FAILED_VALUE = 'failed';
export var PAYPAL_PAYMENT = 'PAYPAL';
export var APGP_PAYMENT = 'APGP';
export var APGP_PLANET_MESSAGE_GP = 'Google pay button clicked';
export var APGP_PLANET_MESSAGE_AP = 'Apple pay button clicked';
export var APPLE = 'APPLE';
export var GOOGLE = 'GOOGLE';
export var WALLET_APPLE = 'WALLET_APPLE';
export var OTHER_ALLOWANCES_CCUI = {
  MEAL_DEAL: {
    type: 'mealDeal',
    name: 'Meal Deal',
    operaId: 'MDP'
  },
  PI_BREAKFAST: {
    type: 'premierInnBreakfast',
    name: 'Premier Inn Breakfast',
    operaId: 'BFADBF'
  },
  CONT_BREAKFAST: {
    type: 'continentalBreakfast',
    name: 'Continental Breakfast',
    operaId: 'BFADCT'
  },
  CAR_PARKING: {
    type: 'carParking',
    name: 'Car Parking',
    operaId: null
  },
  WIFI: {
    type: 'ultimateWifi',
    name: 'Ultimate Wifi',
    operaId: null
  }
};
export var PIBA_NOT_ALLOWED_HOTEL_KEYS = {
  PIBA_EU_ALLOWED_ONLY_IN_EU: 'PIBA_EU_ALLOWED_ONLY_IN_EU',
  PIBA_UK_ALLOWED_ONLY_IN_UK: 'PIBA_UK_ALLOWED_ONLY_IN_UK'
};
export var PAYMENT_REDESIGN_OPTIONS = {
  LED: 'led',
  TAB: 'tab'
};
export var PAYMENT_REDESIGN = 'payment_redesign';
export var THIRTY_MINUTES = 30;
export var DEFAULT_SELECTED_PAYMENT_DETAIL = {
  type: 'default',
  order: 1,
  enabled: false
};